import authentication from "@irati/auth"
import {PBChannel} from "@irati/types/shared"
import channel from "@irati/utils/channel"
import environment from "@irati/utils/constants/environment"
import env from "@irati/utils/env"

// Docs: "/docs/web/devToggles.md"
class DevToggles {
  /**
   * @description: Rolling out VR experience for Wellness (WEL-1763)
   */
  showWellnessVRExample() {
    const allowedDomainsForTesting = ["qa-business", "test-staging-business", "test-prod-business"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showHomePageFestiveCard() {
    const allowedDomainsForTesting = ["kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn", "festive"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showUnreadIndicator() {
    const allowedDomainsForTesting = ["group-recognition", "kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showSSOFeatureFlag() {
    const allowedDomainsForTesting = [
      "home",
      "testaccount1",
      "testaccount2",
      "testaccount3",
      "testaccount4",
      "testaccount5",
      "testaccount6",
      "testaccount12",
      "abcdefg",
      "test-account-self-renewal-training",
      "test-account-upsell",
      "test-account-renew-integ-w-disc"
    ]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  useCheckoutCom() {
    return env.GRAPH_QL === "v2"
  }

  showSendingTeamsSetting() {
    const allowedDomainsForTesting = ["zenitechteam", "guild", "flavio"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showRecommendedBrandsSlider() {
    const allowedDomainsForTesting = ["zenitechteam", "guild", "raultenant", "home"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  isSSOfromVivup() {
    const allowedDomainsForTesting = ["raultenant", "andradasso"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showTopRedeemedPerksCategory() {
    const allowedDomainsForTesting = ["home"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  isPointsBlendEligible() {
    const IS_NOT_PROD = env.ENVIRONMENT_NAME !== environment.PRODUCTION
    if (!authentication.isLoggedIn()) return false

    // on in staging
    if (IS_NOT_PROD) return true

    const users = [
      "81084d22-99ed-4d06-bbee-bd54c45e04f4", // Merlin,  Cox,         merlin.cox@perkbox.com,
      "02610685-b4b1-49ef-9afd-d3145d186af1", // Adam,    Hall,        adam.hall@perkbox.com,
      "ee1d1afa-867f-47d6-acbd-32c4ffd633d8", // Andrada, Tarcuta,     andrada.tarcuta@perkbox.com,
      "7db40939-5537-4a83-862d-67fc68c899d7", // Albert,  Biro,        albert.biro@perkbox.com,
      "c1e3f611-669b-446a-8ca9-1be86bbb5f12", // Alexis,  Miakouikila, alexis.miakouikila@perkbox.com,
      "12383e32-15a8-4e4e-8e9f-f66611b4293d", // Michael, Papworth,    michael.papworth@perkbox.com,
      "e7c4c0a9-36f7-46e5-8a9f-d43c3822ff11", // Maria,   Polikarpova, maria.polikarpova@perkbox.com,
      "a06fff98-ad13-45d6-b980-ded2ebed29a9", // Hardeep, Khera,       hardeep.khera@perkbox.com,
      "2c6adf3f-48a8-4227-aba2-b31dd4654b42", // Adarsh,  Raja,        adarsh.raja@perkbox.com,
      "cca9d45a-cc3b-4ed7-bc84-72d70e5012f2" //  Rajan,   Gupta,       rajan.gupta@perkbox.com,
    ]
    // turned on in prod on WEB AND NATIVE for specific users...
    if (users.includes(authentication.user().uuid || "")) return true

    // off for everyone else on native
    if ([PBChannel.IOS, PBChannel.Android].includes(channel)) {
      return false
    }

    // On in prod WEB for home tenant
    return ["guild", "home"].includes(authentication.business().subdomain ?? "")
  }
}

export default new DevToggles()
